import { Hosts } from '../constants/hostName';

interface IProps {
  firstTitle: string;
  siteNumber: number;
  setTitle: (val:string) => void;
}
export const setPageTitle = ({ siteNumber, setTitle, firstTitle }:IProps) => {
  // All site variants (incl. CPG Media, the bare route) unify to the CPGJobs brand title.
  if (
    Hosts.BEVNET === siteNumber
    || Hosts.NOSH === siteNumber
    || Hosts.BREWBOUND === siteNumber
    || Hosts.CPGJOBS === siteNumber
  ) {
    setTitle(`${firstTitle} | CPGJobs.com by BevNET CPG Media`);
  }
};
